import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	isNoAddressNeeded: ForNodeType<boolean>;
	onSetIsNoAddressNeeded: (value: boolean) => void;
};

export const QuestionPlanIsNoAddressNeeded = ({ isNoAddressNeeded, onSetIsNoAddressNeeded }: Props) => {
	const label = "住所入力不要プラン";
	const guide = "予約する際に住所を入力しなくていいプランに設定できます。住所入力欄自体が表示されません。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label}
			guide={guide}
			isEdited={isNoAddressNeeded.isEdited}
			hasError={Boolean(isNoAddressNeeded.error)}
			inputChildren={
				<CheckboxField
					value={isNoAddressNeeded.value}
					label={"予約する際、住所を入力しなくていいようにする"}
					handleChange={onSetIsNoAddressNeeded}
					errorMessage={isNoAddressNeeded.error}
				/>
			}
		/>
	);
};

QuestionPlanIsNoAddressNeeded.displayName = "QuestionPlanIsNoAddressNeeded";
